import { parseCsvRows } from 'korint-sdk';

/**
 * First row is the header; cells are trimmed and rows are keyed by header.
 * Tokenizing (quotes, CRLF, BOM) lives in korint-sdk's parseCsvRows.
 */
export function parseCsv(input: string): { headers: string[]; rows: Record<string, string>[] } {
  const nonEmpty = parseCsvRows(input).filter(row => row.some(cell => cell.trim() !== ''));
  const [headerRow, ...dataRows] = nonEmpty;
  if (!headerRow) return { headers: [], rows: [] };

  const headers = headerRow.map(header => header.trim());
  const rows = dataRows.map(cells =>
    Object.fromEntries(headers.map((header, index) => [header, (cells[index] ?? '').trim()])),
  );
  return { headers, rows };
}
